// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  AddMySystemData,
  AddMySystemErrors,
  AddMySystemResponses,
  BulkCombinedFactorFromLleData,
  BulkCombinedFactorFromLleErrors,
  BulkCombinedFactorFromLleResponses,
  BulkCombinedFactorFromLlhData,
  BulkCombinedFactorFromLlhErrors,
  BulkCombinedFactorFromLlhResponses,
  BulkCombinedFactorFromNeeData,
  BulkCombinedFactorFromNeeErrors,
  BulkCombinedFactorFromNeeResponses,
  BulkCombinedFactorFromNehData,
  BulkCombinedFactorFromNehErrors,
  BulkCombinedFactorFromNehResponses,
  BulkCombinedFactorFromXyzData,
  BulkCombinedFactorFromXyzErrors,
  BulkCombinedFactorFromXyzResponses,
  BulkConvergenceFromLleData,
  BulkConvergenceFromLleErrors,
  BulkConvergenceFromLleResponses,
  BulkConvergenceFromLlhData,
  BulkConvergenceFromLlhErrors,
  BulkConvergenceFromLlhResponses,
  BulkConvergenceFromNeeData,
  BulkConvergenceFromNeeErrors,
  BulkConvergenceFromNeeResponses,
  BulkConvergenceFromNehData,
  BulkConvergenceFromNehErrors,
  BulkConvergenceFromNehResponses,
  BulkConvergenceFromXyzData,
  BulkConvergenceFromXyzErrors,
  BulkConvergenceFromXyzResponses,
  BulkLleFromLlhData,
  BulkLleFromLlhErrors,
  BulkLleFromLlhResponses,
  BulkLleFromNeeData,
  BulkLleFromNeeErrors,
  BulkLleFromNeeResponses,
  BulkLleFromNehData,
  BulkLleFromNehErrors,
  BulkLleFromNehResponses,
  BulkLleFromXyzData,
  BulkLleFromXyzErrors,
  BulkLleFromXyzResponses,
  BulkLlhFromLleData,
  BulkLlhFromLleErrors,
  BulkLlhFromLleResponses,
  BulkLlhFromLlhData,
  BulkLlhFromLlhErrors,
  BulkLlhFromLlhResponses,
  BulkLlhFromNeeData,
  BulkLlhFromNeeErrors,
  BulkLlhFromNeeResponses,
  BulkLlhFromNehData,
  BulkLlhFromNehErrors,
  BulkLlhFromNehResponses,
  BulkLlhFromXyzData,
  BulkLlhFromXyzErrors,
  BulkLlhFromXyzResponses,
  BulkNeeFromLleData,
  BulkNeeFromLleErrors,
  BulkNeeFromLleResponses,
  BulkNeeFromLlhData,
  BulkNeeFromLlhErrors,
  BulkNeeFromLlhResponses,
  BulkNeeFromNehData,
  BulkNeeFromNehErrors,
  BulkNeeFromNehResponses,
  BulkNeeFromXyzData,
  BulkNeeFromXyzErrors,
  BulkNeeFromXyzResponses,
  BulkNehFromLleData,
  BulkNehFromLleErrors,
  BulkNehFromLleResponses,
  BulkNehFromLlhData,
  BulkNehFromLlhErrors,
  BulkNehFromLlhResponses,
  BulkNehFromNeeData,
  BulkNehFromNeeErrors,
  BulkNehFromNeeResponses,
  BulkNehFromXyzData,
  BulkNehFromXyzErrors,
  BulkNehFromXyzResponses,
  BulkScaleFactorFromLleData,
  BulkScaleFactorFromLleErrors,
  BulkScaleFactorFromLleResponses,
  BulkScaleFactorFromLlhData,
  BulkScaleFactorFromLlhErrors,
  BulkScaleFactorFromLlhResponses,
  BulkScaleFactorFromNeeData,
  BulkScaleFactorFromNeeErrors,
  BulkScaleFactorFromNeeResponses,
  BulkScaleFactorFromNehData,
  BulkScaleFactorFromNehErrors,
  BulkScaleFactorFromNehResponses,
  BulkScaleFactorFromXyzData,
  BulkScaleFactorFromXyzErrors,
  BulkScaleFactorFromXyzResponses,
  BulkXyzFromLleData,
  BulkXyzFromLleErrors,
  BulkXyzFromLleResponses,
  BulkXyzFromLlhData,
  BulkXyzFromLlhErrors,
  BulkXyzFromLlhResponses,
  BulkXyzFromNeeData,
  BulkXyzFromNeeErrors,
  BulkXyzFromNeeResponses,
  BulkXyzFromNehData,
  BulkXyzFromNehErrors,
  BulkXyzFromNehResponses,
  CoordinatesReadmeData,
  CoordinatesReadmeErrors,
  CoordinatesReadmeResponses,
  CoordinateSystemsReadmeData,
  CoordinateSystemsReadmeErrors,
  CoordinateSystemsReadmeResponses,
  CreateCoordinateSystemData,
  CreateCoordinateSystemErrors,
  CreateCoordinateSystemResponses,
  DeleteMySystemData,
  DeleteMySystemErrors,
  DeleteMySystemResponses,
  DeleteProfileByNameData,
  DeleteProfileByNameErrors,
  DeleteProfileByNameResponses,
  DownloadCoordSystemDatabaseData,
  DownloadCoordSystemDatabaseErrors,
  DownloadCoordSystemDatabaseResponses,
  DownloadGeodataFilesData,
  DownloadGeodataFilesErrors,
  DownloadTimeDependentTransformationDatabaseData,
  DownloadTimeDependentTransformationDatabaseErrors,
  GetAliasData,
  GetAliasErrors,
  GetAliasResponses,
  GetAreaData,
  GetAreaErrors,
  GetAreaResponses,
  GetAsGeographicData,
  GetAsGeographicErrors,
  GetAsGeographicResponses,
  GetCalibrationFileData,
  GetCalibrationFileErrors,
  GetCalibrationFileResponses,
  GetCombinedFactorFromLleData,
  GetCombinedFactorFromLleErrors,
  GetCombinedFactorFromLleResponses,
  GetCombinedFactorFromLlhData,
  GetCombinedFactorFromLlhErrors,
  GetCombinedFactorFromLlhResponses,
  GetCombinedFactorFromNeeData,
  GetCombinedFactorFromNeeErrors,
  GetCombinedFactorFromNeeResponses,
  GetCombinedFactorFromNehData,
  GetCombinedFactorFromNehErrors,
  GetCombinedFactorFromNehResponses,
  GetCombinedFactorFromXyzData,
  GetCombinedFactorFromXyzErrors,
  GetCombinedFactorFromXyzResponses,
  GetCombinedFactorsData,
  GetCombinedFactorsErrors,
  GetCombinedFactorsResponses,
  GetComponentByAliasData,
  GetComponentByAliasErrors,
  GetComponentByAliasResponses,
  GetComponentByCsIdData,
  GetComponentByCsIdErrors,
  GetComponentByCsIdResponses,
  GetComponentData,
  GetComponentErrors,
  GetComponentFileSizeData,
  GetComponentFileSizeErrors,
  GetComponentFileSizeResponses,
  GetComponentResponses,
  GetComponentsByAliasData,
  GetComponentsByAliasErrors,
  GetComponentsByAliasResponses,
  GetConvergencesData,
  GetConvergencesErrors,
  GetConvergencesResponses,
  GetCoordinateSystemBySystemIdsData,
  GetCoordinateSystemBySystemIdsErrors,
  GetCoordinateSystemBySystemIdsResponses,
  GetCoordinatesystemcomponentsAdminExportsCscmdbData,
  GetCoordinatesystemcomponentsAdminExportsCscmdbErrors,
  GetCoordinatesystemcomponentsAdminExportsCscmdbResponses,
  GetCoordinatesystemcomponentsAdminExportsCsdxmlData,
  GetCoordinatesystemcomponentsAdminExportsCsdxmlErrors,
  GetCoordinatesystemcomponentsAdminExportsCsdxmlResponses,
  GetCoordinatesystemcomponentsAdminVersionData,
  GetCoordinatesystemcomponentsAdminVersionErrors,
  GetCoordinatesystemcomponentsAdminVersionResponses,
  GetCoordinateSystemData,
  GetCoordinateSystemErrors,
  GetCoordinateSystemFromCustomDatumData,
  GetCoordinateSystemFromCustomDatumErrors,
  GetCoordinateSystemFromCustomDatumResponses,
  GetCoordinateSystemResponses,
  GetCsib64Data,
  GetCsib64Errors,
  GetCsib64Responses,
  GetCsibData,
  GetCsibErrors,
  GetCsibResponses,
  GetData,
  GetDatumData,
  GetDatumErrors,
  GetDatumResponses,
  GetDatumTransformationData,
  GetDatumTransformationErrors,
  GetDatumTransformationResponses,
  GetDownloadLinksData,
  GetDownloadLinksErrors,
  GetDownloadLinksResponses,
  GetErrors,
  GetFromBase64CsibData,
  GetFromBase64CsibErrors,
  GetFromBase64CsibResponses,
  GetFromCsibData,
  GetFromCsibErrors,
  GetFromCsibResponses,
  GetFromDcData,
  GetFromDcErrors,
  GetFromDcFileData,
  GetFromDcFileErrors,
  GetFromDcFileResponses,
  GetFromDcResponses,
  GetFromEpsgData,
  GetFromEpsgErrors,
  GetFromEpsgResponses,
  GetFromJxlData,
  GetFromJxlErrors,
  GetFromJxlFileData,
  GetFromJxlFileErrors,
  GetFromJxlFileResponses,
  GetFromJxlResponses,
  GetFromWktData,
  GetFromWktErrors,
  GetFromWktFileData,
  GetFromWktFileErrors,
  GetFromWktFileResponses,
  GetFromWktResponses,
  GetGeodataFileSizeData,
  GetGeodataFileSizeErrors,
  GetGeodataFileSizeResponses,
  GetGeoidData,
  GetGeoidErrors,
  GetGeoidResponses,
  GetGetConvergenceFromLleData,
  GetGetConvergenceFromLleErrors,
  GetGetConvergenceFromLleResponses,
  GetGetConvergenceFromLlhData,
  GetGetConvergenceFromLlhErrors,
  GetGetConvergenceFromLlhResponses,
  GetGetConvergenceFromNeeData,
  GetGetConvergenceFromNeeErrors,
  GetGetConvergenceFromNeeResponses,
  GetGetConvergenceFromNehData,
  GetGetConvergenceFromNehErrors,
  GetGetConvergenceFromNehResponses,
  GetGetConvergenceFromXyzData,
  GetGetConvergenceFromXyzErrors,
  GetGetConvergenceFromXyzResponses,
  GetJxlByEpsgData,
  GetJxlByEpsgErrors,
  GetJxlByEpsgResponses,
  GetJxlData,
  GetJxlErrors,
  GetJxlResponses,
  GetLleFromLlhData,
  GetLleFromLlhErrors,
  GetLleFromLlhResponses,
  GetLleFromNeeData,
  GetLleFromNeeErrors,
  GetLleFromNeeResponses,
  GetLleFromNehData,
  GetLleFromNehErrors,
  GetLleFromNehResponses,
  GetLleFromXyzData,
  GetLleFromXyzErrors,
  GetLleFromXyzResponses,
  GetLlhFromLleData,
  GetLlhFromLleErrors,
  GetLlhFromLleResponses,
  GetLlhFromLlhData,
  GetLlhFromLlhErrors,
  GetLlhFromLlhResponses,
  GetLlhFromNeeData,
  GetLlhFromNeeErrors,
  GetLlhFromNeeResponses,
  GetLlhFromNehData,
  GetLlhFromNehErrors,
  GetLlhFromNehResponses,
  GetLlhFromXyzData,
  GetLlhFromXyzErrors,
  GetLlhFromXyzResponses,
  GetNeeFromLleData,
  GetNeeFromLleErrors,
  GetNeeFromLleResponses,
  GetNeeFromLlhData,
  GetNeeFromLlhErrors,
  GetNeeFromLlhResponses,
  GetNeeFromNehData,
  GetNeeFromNehErrors,
  GetNeeFromNehResponses,
  GetNeeFromXyzData,
  GetNeeFromXyzErrors,
  GetNeeFromXyzResponses,
  GetNehFromLleData,
  GetNehFromLleErrors,
  GetNehFromLleResponses,
  GetNehFromLlhData,
  GetNehFromLlhErrors,
  GetNehFromLlhResponses,
  GetNehFromNeeData,
  GetNehFromNeeErrors,
  GetNehFromNeeResponses,
  GetNehFromXyzData,
  GetNehFromXyzErrors,
  GetNehFromXyzResponses,
  GetProfileByNameData,
  GetProfileByNameErrors,
  GetProfileByNameResponses,
  GetProfilesData,
  GetProfilesErrors,
  GetProfilesResponses,
  GetReferenceFrameData,
  GetReferenceFrameErrors,
  GetReferenceFrameResponses,
  GetResponses,
  GetRftibData,
  GetRftibErrors,
  GetRftibResponses,
  GetScaleFactorFromLleData,
  GetScaleFactorFromLleErrors,
  GetScaleFactorFromLleResponses,
  GetScaleFactorFromLlhData,
  GetScaleFactorFromLlhErrors,
  GetScaleFactorFromLlhResponses,
  GetScaleFactorFromNeeData,
  GetScaleFactorFromNeeErrors,
  GetScaleFactorFromNeeResponses,
  GetScaleFactorFromNehData,
  GetScaleFactorFromNehErrors,
  GetScaleFactorFromNehResponses,
  GetScaleFactorFromXyzData,
  GetScaleFactorFromXyzErrors,
  GetScaleFactorFromXyzResponses,
  GetScaleFactorsData,
  GetScaleFactorsErrors,
  GetScaleFactorsResponses,
  GetShiftGridInfoData,
  GetShiftGridInfoErrors,
  GetShiftGridInfoResponses,
  GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCscmdbData,
  GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCscmdbErrors,
  GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCscmdbResponses,
  GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCsdxmlData,
  GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCsdxmlErrors,
  GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCsdxmlResponses,
  GetWktAngularUnitsData,
  GetWktAngularUnitsErrors,
  GetWktAngularUnitsResponses,
  GetWktData,
  GetWktErrors,
  GetWktFromEpsgData,
  GetWktFromEpsgErrors,
  GetWktFromEpsgResponses,
  GetWktLinearUnitsData,
  GetWktLinearUnitsErrors,
  GetWktLinearUnitsResponses,
  GetWktResponses,
  GetXyzFromLleData,
  GetXyzFromLleErrors,
  GetXyzFromLleResponses,
  GetXyzFromLlhData,
  GetXyzFromLlhErrors,
  GetXyzFromLlhResponses,
  GetXyzFromNeeData,
  GetXyzFromNeeErrors,
  GetXyzFromNeeResponses,
  GetXyzFromNehData,
  GetXyzFromNehErrors,
  GetXyzFromNehResponses,
  GetZoneData,
  GetZoneDefaultDatumData,
  GetZoneDefaultDatumErrors,
  GetZoneDefaultDatumResponses,
  GetZoneDefaultGeoidData,
  GetZoneDefaultGeoidErrors,
  GetZoneDefaultGeoidResponses,
  GetZoneErrors,
  GetZoneGroupData,
  GetZoneGroupErrors,
  GetZoneGroupResponses,
  GetZoneResponses,
  ListAliasesData,
  ListAliasesErrors,
  ListAliasesResponses,
  ListAllZonesData,
  ListAllZonesErrors,
  ListAllZonesResponses,
  ListAreasData,
  ListAreasErrors,
  ListAreasResponses,
  ListComponentsData,
  ListComponentsErrors,
  ListComponentsResponses,
  ListDatumsData,
  ListDatumsErrors,
  ListDatumsResponses,
  ListFilesData,
  ListFilesErrors,
  ListFilesResponses,
  ListGeoidsData,
  ListGeoidsErrors,
  ListGeoidsResponses,
  ListMySystemsData,
  ListMySystemsErrors,
  ListMySystemsResponses,
  ListReferenceFramesData,
  ListReferenceFramesErrors,
  ListReferenceFramesResponses,
  ListSystemsData,
  ListSystemsErrors,
  ListSystemsResponses,
  ListZoneGroupsData,
  ListZoneGroupsErrors,
  ListZoneGroupsResponses,
  ListZonesInGroupData,
  ListZonesInGroupErrors,
  ListZonesInGroupResponses,
  ObsoleteListZonesInGroupData,
  ObsoleteListZonesInGroupErrors,
  ObsoleteListZonesInGroupResponses,
  PostGeodataFilesData,
  PostGeodataFilesErrors,
  PostGeodataFilesResponses,
  PostProfilesData,
  PostProfilesErrors,
  PostProfilesResponses,
  PutCoordinatesystemcomponentsCompositionsWktData,
  PutCoordinatesystemcomponentsCompositionsWktErrors,
  PutCoordinatesystemcomponentsCompositionsWktResponses,
  PutProfilesData,
  PutProfilesErrors,
  PutProfilesResponses,
  PutTenantsByTenantTrnCoordinatesystemcomponentsCompositionsWktData,
  PutTenantsByTenantTrnCoordinatesystemcomponentsCompositionsWktErrors,
  PutTenantsByTenantTrnCoordinatesystemcomponentsCompositionsWktResponses,
  TenantedCreateCoordinateSystemData,
  TenantedCreateCoordinateSystemErrors,
  TenantedCreateCoordinateSystemResponses,
  TenantedDownloadCoordSystemDatabaseData,
  TenantedDownloadCoordSystemDatabaseErrors,
  TenantedDownloadCoordSystemDatabaseResponses,
  TenantedDownloadGeodataFilesData,
  TenantedDownloadGeodataFilesErrors,
  TenantedDownloadTimeDependentTransformationDatabaseData,
  TenantedDownloadTimeDependentTransformationDatabaseErrors,
  TenantedGetAliasData,
  TenantedGetAliasErrors,
  TenantedGetAliasResponses,
  TenantedGetAreaData,
  TenantedGetAreaErrors,
  TenantedGetAreaResponses,
  TenantedGetAsGeographicData,
  TenantedGetAsGeographicErrors,
  TenantedGetAsGeographicResponses,
  TenantedGetCalibrationFileData,
  TenantedGetCalibrationFileErrors,
  TenantedGetCalibrationFileResponses,
  TenantedGetCombinedFactorsData,
  TenantedGetCombinedFactorsErrors,
  TenantedGetCombinedFactorsResponses,
  TenantedGetComponentByAliasData,
  TenantedGetComponentByAliasErrors,
  TenantedGetComponentByAliasResponses,
  TenantedGetComponentByCsIdData,
  TenantedGetComponentByCsIdErrors,
  TenantedGetComponentByCsIdResponses,
  TenantedGetComponentData,
  TenantedGetComponentErrors,
  TenantedGetComponentFileSizeData,
  TenantedGetComponentFileSizeErrors,
  TenantedGetComponentFileSizeResponses,
  TenantedGetComponentResponses,
  TenantedGetComponentsByAliasData,
  TenantedGetComponentsByAliasErrors,
  TenantedGetComponentsByAliasResponses,
  TenantedGetConvergencesData,
  TenantedGetConvergencesErrors,
  TenantedGetConvergencesResponses,
  TenantedGetCoordinateSystemBySystemIdsData,
  TenantedGetCoordinateSystemBySystemIdsErrors,
  TenantedGetCoordinateSystemBySystemIdsResponses,
  TenantedGetCoordinateSystemData,
  TenantedGetCoordinateSystemErrors,
  TenantedGetCoordinateSystemFromCustomDatumData,
  TenantedGetCoordinateSystemFromCustomDatumErrors,
  TenantedGetCoordinateSystemFromCustomDatumResponses,
  TenantedGetCoordinateSystemResponses,
  TenantedGetCsib64Data,
  TenantedGetCsib64Errors,
  TenantedGetCsib64Responses,
  TenantedGetCsibData,
  TenantedGetCsibErrors,
  TenantedGetCsibResponses,
  TenantedGetData,
  TenantedGetDatumData,
  TenantedGetDatumErrors,
  TenantedGetDatumResponses,
  TenantedGetDatumTransformationData,
  TenantedGetDatumTransformationErrors,
  TenantedGetDatumTransformationResponses,
  TenantedGetDownloadLinksData,
  TenantedGetDownloadLinksErrors,
  TenantedGetDownloadLinksResponses,
  TenantedGetErrors,
  TenantedGetFromBase64CsibData,
  TenantedGetFromBase64CsibErrors,
  TenantedGetFromBase64CsibResponses,
  TenantedGetFromCsibData,
  TenantedGetFromCsibErrors,
  TenantedGetFromCsibResponses,
  TenantedGetFromDcData,
  TenantedGetFromDcErrors,
  TenantedGetFromDcFileData,
  TenantedGetFromDcFileErrors,
  TenantedGetFromDcFileResponses,
  TenantedGetFromDcResponses,
  TenantedGetFromEpsgData,
  TenantedGetFromEpsgErrors,
  TenantedGetFromEpsgResponses,
  TenantedGetFromJxlData,
  TenantedGetFromJxlErrors,
  TenantedGetFromJxlFileData,
  TenantedGetFromJxlFileErrors,
  TenantedGetFromJxlFileResponses,
  TenantedGetFromJxlResponses,
  TenantedGetFromWktData,
  TenantedGetFromWktErrors,
  TenantedGetFromWktFileData,
  TenantedGetFromWktFileErrors,
  TenantedGetFromWktFileResponses,
  TenantedGetFromWktResponses,
  TenantedGetGeodataFilesSizeData,
  TenantedGetGeodataFilesSizeErrors,
  TenantedGetGeodataFilesSizeResponses,
  TenantedGetGeoidData,
  TenantedGetGeoidErrors,
  TenantedGetGeoidResponses,
  TenantedGetJxlByEpsgData,
  TenantedGetJxlByEpsgErrors,
  TenantedGetJxlByEpsgResponses,
  TenantedGetJxlData,
  TenantedGetJxlErrors,
  TenantedGetJxlResponses,
  TenantedGetReferenceFrameData,
  TenantedGetReferenceFrameErrors,
  TenantedGetReferenceFrameResponses,
  TenantedGetResponses,
  TenantedGetRftibData,
  TenantedGetRftibErrors,
  TenantedGetRftibResponses,
  TenantedGetScaleFactorsData,
  TenantedGetScaleFactorsErrors,
  TenantedGetScaleFactorsResponses,
  TenantedGetShiftGridInfoData,
  TenantedGetShiftGridInfoErrors,
  TenantedGetShiftGridInfoResponses,
  TenantedGetWktAngularUnitsData,
  TenantedGetWktAngularUnitsErrors,
  TenantedGetWktAngularUnitsResponses,
  TenantedGetWktData,
  TenantedGetWktErrors,
  TenantedGetWktFromEpsgData,
  TenantedGetWktFromEpsgErrors,
  TenantedGetWktFromEpsgResponses,
  TenantedGetWktLinearUnitsData,
  TenantedGetWktLinearUnitsErrors,
  TenantedGetWktLinearUnitsResponses,
  TenantedGetWktResponses,
  TenantedGetZoneData,
  TenantedGetZoneDefaultDatumData,
  TenantedGetZoneDefaultDatumErrors,
  TenantedGetZoneDefaultDatumResponses,
  TenantedGetZoneDefaultGeoidData,
  TenantedGetZoneDefaultGeoidErrors,
  TenantedGetZoneDefaultGeoidResponses,
  TenantedGetZoneErrors,
  TenantedGetZoneGroupData,
  TenantedGetZoneGroupErrors,
  TenantedGetZoneGroupResponses,
  TenantedGetZoneResponses,
  TenantedListAliasesData,
  TenantedListAliasesErrors,
  TenantedListAliasesResponses,
  TenantedListAllZonesData,
  TenantedListAllZonesErrors,
  TenantedListAllZonesResponses,
  TenantedListAreasData,
  TenantedListAreasErrors,
  TenantedListAreasResponses,
  TenantedListComponentsData,
  TenantedListComponentsErrors,
  TenantedListComponentsResponses,
  TenantedListDatumsData,
  TenantedListDatumsErrors,
  TenantedListDatumsResponses,
  TenantedListFilesData,
  TenantedListFilesErrors,
  TenantedListFilesResponses,
  TenantedListGeoidsData,
  TenantedListGeoidsErrors,
  TenantedListGeoidsResponses,
  TenantedListReferenceFramesData,
  TenantedListReferenceFramesErrors,
  TenantedListReferenceFramesResponses,
  TenantedListSystemsData,
  TenantedListSystemsErrors,
  TenantedListSystemsResponses,
  TenantedListZoneGroupsData,
  TenantedListZoneGroupsErrors,
  TenantedListZoneGroupsResponses,
  TenantedListZonesInGroupData,
  TenantedListZonesInGroupErrors,
  TenantedListZonesInGroupResponses,
  TenantedTransformCoordinatesData,
  TenantedTransformCoordinatesErrors,
  TenantedTransformCoordinatesResponses,
  TenantedTransformToEcefGlobalData,
  TenantedTransformToEcefGlobalErrors,
  TenantedTransformToEcefGlobalResponses,
  TenantedTransformToGlobalData,
  TenantedTransformToGlobalErrors,
  TenantedTransformToGlobalResponses,
  TenantedTransformToLocalData,
  TenantedTransformToLocalErrors,
  TenantedTransformToLocalResponses,
  TransformCoordinatesData,
  TransformCoordinatesErrors,
  TransformCoordinatesResponses,
  TransformsReadmeData,
  TransformsReadmeErrors,
  TransformsReadmeResponses,
  TransformToEcefGlobalData,
  TransformToEcefGlobalErrors,
  TransformToEcefGlobalResponses,
  TransformToGlobalData,
  TransformToGlobalErrors,
  TransformToGlobalResponses,
  TransformToLocalData,
  TransformToLocalErrors,
  TransformToLocalResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Redirects to a geodata file download URL.
 *
 * Redirects to a geodata file download URL.
 */
export const tenantedDownloadGeodataFiles = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedDownloadGeodataFilesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    unknown,
    TenantedDownloadGeodataFilesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/geodataFiles',
    ...options,
  });

/**
 * Request file upload URL(s).
 *
 * Request file upload URL(s).
 */
export const postGeodataFiles = <ThrowOnError extends boolean = false>(
  options: Options<PostGeodataFilesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PostGeodataFilesResponses,
    PostGeodataFilesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/geodataFiles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete a specific tenanted Coordinate System profile.
 *
 * Delete a tenanted Coordinate System Profile.
 */
export const deleteProfileByName = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProfileByNameData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteProfileByNameResponses,
    DeleteProfileByNameErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/profiles/{profileName}',
    ...options,
  });

/**
 * Get a specific tenanted Coordinate System profile.
 *
 * Get a tenanted Coordinate System Profile.
 */
export const getProfileByName = <ThrowOnError extends boolean = false>(
  options: Options<GetProfileByNameData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProfileByNameResponses,
    GetProfileByNameErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/profiles/{profileName}',
    ...options,
  });

/**
 * Update the tenanted default Coordinate System profile.
 *
 * Update a tenanted Coordinate System Profile.
 */
export const putProfiles = <ThrowOnError extends boolean = false>(
  options: Options<PutProfilesData, ThrowOnError>
) =>
  (options.client ?? client).put<
    PutProfilesResponses,
    PutProfilesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/profiles/{profileName}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List all tenanted Coordinate System profiles.
 *
 * List all tenanted Coordinate System Profiles.
 */
export const getProfiles = <ThrowOnError extends boolean = false>(
  options: Options<GetProfilesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProfilesResponses,
    GetProfilesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/profiles',
    ...options,
  });

/**
 * Create a tenanted Coordinate System profile (default profile).
 *
 * Create a tenanted Coordinate System Profile.
 */
export const postProfiles = <ThrowOnError extends boolean = false>(
  options: Options<PostProfilesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PostProfilesResponses,
    PostProfilesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/profiles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const coordinatesReadme = <ThrowOnError extends boolean = false>(
  options?: Options<CoordinatesReadmeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    CoordinatesReadmeResponses,
    CoordinatesReadmeErrors,
    ThrowOnError
  >({ url: '/coordinates/_README', ...options });

export const getNeeFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<GetNeeFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetNeeFromLlhResponses,
    GetNeeFromLlhErrors,
    ThrowOnError
  >({ url: '/coordinates/nee/{neeType}/fromLLH', ...options });

export const bulkNeeFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<BulkNeeFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNeeFromLlhResponses,
    BulkNeeFromLlhErrors,
    ThrowOnError
  >({
    url: '/coordinates/nee/{neeType}/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getNeeFromLle = <ThrowOnError extends boolean = false>(
  options: Options<GetNeeFromLleData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetNeeFromLleResponses,
    GetNeeFromLleErrors,
    ThrowOnError
  >({ url: '/coordinates/nee/{neeType}/fromLLE', ...options });

export const bulkNeeFromLle = <ThrowOnError extends boolean = false>(
  options: Options<BulkNeeFromLleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNeeFromLleResponses,
    BulkNeeFromLleErrors,
    ThrowOnError
  >({
    url: '/coordinates/nee/{neeType}/fromLLE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getNeeFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<GetNeeFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetNeeFromXyzResponses,
    GetNeeFromXyzErrors,
    ThrowOnError
  >({ url: '/coordinates/nee/{neeType}/fromXYZ', ...options });

export const bulkNeeFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<BulkNeeFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNeeFromXyzResponses,
    BulkNeeFromXyzErrors,
    ThrowOnError
  >({
    url: '/coordinates/nee/{neeType}/fromXYZ',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getNeeFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<GetNeeFromNehData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetNeeFromNehResponses,
    GetNeeFromNehErrors,
    ThrowOnError
  >({ url: '/coordinates/nee/{neeType}/fromNEH', ...options });

export const bulkNeeFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<BulkNeeFromNehData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNeeFromNehResponses,
    BulkNeeFromNehErrors,
    ThrowOnError
  >({
    url: '/coordinates/nee/{neeType}/fromNEH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getNehFromNee = <ThrowOnError extends boolean = false>(
  options: Options<GetNehFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetNehFromNeeResponses,
    GetNehFromNeeErrors,
    ThrowOnError
  >({ url: '/coordinates/neh/{nehType}/fromNEE', ...options });

export const bulkNehFromNee = <ThrowOnError extends boolean = false>(
  options: Options<BulkNehFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNehFromNeeResponses,
    BulkNehFromNeeErrors,
    ThrowOnError
  >({
    url: '/coordinates/neh/{nehType}/fromNEE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getNehFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<GetNehFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetNehFromLlhResponses,
    GetNehFromLlhErrors,
    ThrowOnError
  >({ url: '/coordinates/neh/{nehType}/fromLLH', ...options });

export const bulkNehFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<BulkNehFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNehFromLlhResponses,
    BulkNehFromLlhErrors,
    ThrowOnError
  >({
    url: '/coordinates/neh/{nehType}/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getNehFromLle = <ThrowOnError extends boolean = false>(
  options: Options<GetNehFromLleData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetNehFromLleResponses,
    GetNehFromLleErrors,
    ThrowOnError
  >({ url: '/coordinates/neh/{nehType}/fromLLE', ...options });

export const bulkNehFromLle = <ThrowOnError extends boolean = false>(
  options: Options<BulkNehFromLleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNehFromLleResponses,
    BulkNehFromLleErrors,
    ThrowOnError
  >({
    url: '/coordinates/neh/{nehType}/fromLLE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getNehFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<GetNehFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetNehFromXyzResponses,
    GetNehFromXyzErrors,
    ThrowOnError
  >({ url: '/coordinates/neh/{nehType}/fromXYZ', ...options });

export const bulkNehFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<BulkNehFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNehFromXyzResponses,
    BulkNehFromXyzErrors,
    ThrowOnError
  >({
    url: '/coordinates/neh/{nehType}/fromXYZ',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLlhFromNee = <ThrowOnError extends boolean = false>(
  options: Options<GetLlhFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetLlhFromNeeResponses,
    GetLlhFromNeeErrors,
    ThrowOnError
  >({ url: '/coordinates/llh/{llhType}/fromNEE', ...options });

export const bulkLlhFromNee = <ThrowOnError extends boolean = false>(
  options: Options<BulkLlhFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLlhFromNeeResponses,
    BulkLlhFromNeeErrors,
    ThrowOnError
  >({
    url: '/coordinates/llh/{llhType}/fromNEE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLlhFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<GetLlhFromNehData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetLlhFromNehResponses,
    GetLlhFromNehErrors,
    ThrowOnError
  >({ url: '/coordinates/llh/{llhType}/fromNEH', ...options });

export const bulkLlhFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<BulkLlhFromNehData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLlhFromNehResponses,
    BulkLlhFromNehErrors,
    ThrowOnError
  >({
    url: '/coordinates/llh/{llhType}/fromNEH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLlhFromLle = <ThrowOnError extends boolean = false>(
  options: Options<GetLlhFromLleData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetLlhFromLleResponses,
    GetLlhFromLleErrors,
    ThrowOnError
  >({ url: '/coordinates/llh/{llhType}/fromLLE', ...options });

export const bulkLlhFromLle = <ThrowOnError extends boolean = false>(
  options: Options<BulkLlhFromLleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLlhFromLleResponses,
    BulkLlhFromLleErrors,
    ThrowOnError
  >({
    url: '/coordinates/llh/{llhType}/fromLLE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLlhFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<GetLlhFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetLlhFromXyzResponses,
    GetLlhFromXyzErrors,
    ThrowOnError
  >({ url: '/coordinates/llh/{llhType}/fromXYZ', ...options });

export const bulkLlhFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<BulkLlhFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLlhFromXyzResponses,
    BulkLlhFromXyzErrors,
    ThrowOnError
  >({
    url: '/coordinates/llh/{llhType}/fromXYZ',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLlhFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<GetLlhFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetLlhFromLlhResponses,
    GetLlhFromLlhErrors,
    ThrowOnError
  >({ url: '/coordinates/llh/{llhType}/fromLLH', ...options });

export const bulkLlhFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<BulkLlhFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLlhFromLlhResponses,
    BulkLlhFromLlhErrors,
    ThrowOnError
  >({
    url: '/coordinates/llh/{llhType}/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLleFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<GetLleFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetLleFromLlhResponses,
    GetLleFromLlhErrors,
    ThrowOnError
  >({ url: '/coordinates/lle/{lleType}/fromLLH', ...options });

export const bulkLleFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<BulkLleFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLleFromLlhResponses,
    BulkLleFromLlhErrors,
    ThrowOnError
  >({
    url: '/coordinates/lle/{lleType}/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLleFromNee = <ThrowOnError extends boolean = false>(
  options: Options<GetLleFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetLleFromNeeResponses,
    GetLleFromNeeErrors,
    ThrowOnError
  >({ url: '/coordinates/lle/{lleType}/fromNEE', ...options });

export const bulkLleFromNee = <ThrowOnError extends boolean = false>(
  options: Options<BulkLleFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLleFromNeeResponses,
    BulkLleFromNeeErrors,
    ThrowOnError
  >({
    url: '/coordinates/lle/{lleType}/fromNEE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLleFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<GetLleFromNehData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetLleFromNehResponses,
    GetLleFromNehErrors,
    ThrowOnError
  >({ url: '/coordinates/lle/{lleType}/fromNEH', ...options });

export const bulkLleFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<BulkLleFromNehData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLleFromNehResponses,
    BulkLleFromNehErrors,
    ThrowOnError
  >({
    url: '/coordinates/lle/{lleType}/fromNEH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLleFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<GetLleFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetLleFromXyzResponses,
    GetLleFromXyzErrors,
    ThrowOnError
  >({ url: '/coordinates/lle/{lleType}/fromXYZ', ...options });

export const bulkLleFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<BulkLleFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLleFromXyzResponses,
    BulkLleFromXyzErrors,
    ThrowOnError
  >({
    url: '/coordinates/lle/{lleType}/fromXYZ',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getXyzFromNee = <ThrowOnError extends boolean = false>(
  options: Options<GetXyzFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetXyzFromNeeResponses,
    GetXyzFromNeeErrors,
    ThrowOnError
  >({ url: '/coordinates/xyz/{xyzType}/fromNEE', ...options });

export const bulkXyzFromNee = <ThrowOnError extends boolean = false>(
  options: Options<BulkXyzFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkXyzFromNeeResponses,
    BulkXyzFromNeeErrors,
    ThrowOnError
  >({
    url: '/coordinates/xyz/{xyzType}/fromNEE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getXyzFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<GetXyzFromNehData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetXyzFromNehResponses,
    GetXyzFromNehErrors,
    ThrowOnError
  >({ url: '/coordinates/xyz/{xyzType}/fromNEH', ...options });

export const bulkXyzFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<BulkXyzFromNehData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkXyzFromNehResponses,
    BulkXyzFromNehErrors,
    ThrowOnError
  >({
    url: '/coordinates/xyz/{xyzType}/fromNEH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getXyzFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<GetXyzFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetXyzFromLlhResponses,
    GetXyzFromLlhErrors,
    ThrowOnError
  >({ url: '/coordinates/xyz/{xyzType}/fromLLH', ...options });

export const bulkXyzFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<BulkXyzFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkXyzFromLlhResponses,
    BulkXyzFromLlhErrors,
    ThrowOnError
  >({
    url: '/coordinates/xyz/{xyzType}/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getXyzFromLle = <ThrowOnError extends boolean = false>(
  options: Options<GetXyzFromLleData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetXyzFromLleResponses,
    GetXyzFromLleErrors,
    ThrowOnError
  >({ url: '/coordinates/xyz/{xyzType}/fromLLE', ...options });

export const bulkXyzFromLle = <ThrowOnError extends boolean = false>(
  options: Options<BulkXyzFromLleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkXyzFromLleResponses,
    BulkXyzFromLleErrors,
    ThrowOnError
  >({
    url: '/coordinates/xyz/{xyzType}/fromLLE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getScaleFactorFromLlh = <ThrowOnError extends boolean = false>(
  options?: Options<GetScaleFactorFromLlhData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetScaleFactorFromLlhResponses,
    GetScaleFactorFromLlhErrors,
    ThrowOnError
  >({ url: '/coordinates/scaleFactor/fromLLH', ...options });

export const bulkScaleFactorFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<BulkScaleFactorFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkScaleFactorFromLlhResponses,
    BulkScaleFactorFromLlhErrors,
    ThrowOnError
  >({
    url: '/coordinates/scaleFactor/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getScaleFactorFromLle = <ThrowOnError extends boolean = false>(
  options?: Options<GetScaleFactorFromLleData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetScaleFactorFromLleResponses,
    GetScaleFactorFromLleErrors,
    ThrowOnError
  >({ url: '/coordinates/scaleFactor/fromLLE', ...options });

export const bulkScaleFactorFromLle = <ThrowOnError extends boolean = false>(
  options: Options<BulkScaleFactorFromLleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkScaleFactorFromLleResponses,
    BulkScaleFactorFromLleErrors,
    ThrowOnError
  >({
    url: '/coordinates/scaleFactor/fromLLE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getScaleFactorFromXyz = <ThrowOnError extends boolean = false>(
  options?: Options<GetScaleFactorFromXyzData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetScaleFactorFromXyzResponses,
    GetScaleFactorFromXyzErrors,
    ThrowOnError
  >({ url: '/coordinates/scaleFactor/fromXYZ', ...options });

export const bulkScaleFactorFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<BulkScaleFactorFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkScaleFactorFromXyzResponses,
    BulkScaleFactorFromXyzErrors,
    ThrowOnError
  >({
    url: '/coordinates/scaleFactor/fromXYZ',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getScaleFactorFromNee = <ThrowOnError extends boolean = false>(
  options?: Options<GetScaleFactorFromNeeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetScaleFactorFromNeeResponses,
    GetScaleFactorFromNeeErrors,
    ThrowOnError
  >({ url: '/coordinates/scaleFactor/fromNEE', ...options });

export const bulkScaleFactorFromNee = <ThrowOnError extends boolean = false>(
  options: Options<BulkScaleFactorFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkScaleFactorFromNeeResponses,
    BulkScaleFactorFromNeeErrors,
    ThrowOnError
  >({
    url: '/coordinates/scaleFactor/fromNEE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getScaleFactorFromNeh = <ThrowOnError extends boolean = false>(
  options?: Options<GetScaleFactorFromNehData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetScaleFactorFromNehResponses,
    GetScaleFactorFromNehErrors,
    ThrowOnError
  >({ url: '/coordinates/scaleFactor/fromNEH', ...options });

export const bulkScaleFactorFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<BulkScaleFactorFromNehData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkScaleFactorFromNehResponses,
    BulkScaleFactorFromNehErrors,
    ThrowOnError
  >({
    url: '/coordinates/scaleFactor/fromNEH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getCombinedFactorFromLlh = <ThrowOnError extends boolean = false>(
  options?: Options<GetCombinedFactorFromLlhData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCombinedFactorFromLlhResponses,
    GetCombinedFactorFromLlhErrors,
    ThrowOnError
  >({ url: '/coordinates/combinedFactor/fromLLH', ...options });

export const bulkCombinedFactorFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<BulkCombinedFactorFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkCombinedFactorFromLlhResponses,
    BulkCombinedFactorFromLlhErrors,
    ThrowOnError
  >({
    url: '/coordinates/combinedFactor/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getCombinedFactorFromLle = <ThrowOnError extends boolean = false>(
  options?: Options<GetCombinedFactorFromLleData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCombinedFactorFromLleResponses,
    GetCombinedFactorFromLleErrors,
    ThrowOnError
  >({ url: '/coordinates/combinedFactor/fromLLE', ...options });

export const bulkCombinedFactorFromLle = <ThrowOnError extends boolean = false>(
  options: Options<BulkCombinedFactorFromLleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkCombinedFactorFromLleResponses,
    BulkCombinedFactorFromLleErrors,
    ThrowOnError
  >({
    url: '/coordinates/combinedFactor/fromLLE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getCombinedFactorFromXyz = <ThrowOnError extends boolean = false>(
  options?: Options<GetCombinedFactorFromXyzData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCombinedFactorFromXyzResponses,
    GetCombinedFactorFromXyzErrors,
    ThrowOnError
  >({ url: '/coordinates/combinedFactor/fromXYZ', ...options });

export const bulkCombinedFactorFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<BulkCombinedFactorFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkCombinedFactorFromXyzResponses,
    BulkCombinedFactorFromXyzErrors,
    ThrowOnError
  >({
    url: '/coordinates/combinedFactor/fromXYZ',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getCombinedFactorFromNee = <ThrowOnError extends boolean = false>(
  options?: Options<GetCombinedFactorFromNeeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCombinedFactorFromNeeResponses,
    GetCombinedFactorFromNeeErrors,
    ThrowOnError
  >({ url: '/coordinates/combinedFactor/fromNEE', ...options });

export const bulkCombinedFactorFromNee = <ThrowOnError extends boolean = false>(
  options: Options<BulkCombinedFactorFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkCombinedFactorFromNeeResponses,
    BulkCombinedFactorFromNeeErrors,
    ThrowOnError
  >({
    url: '/coordinates/combinedFactor/fromNEE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getCombinedFactorFromNeh = <ThrowOnError extends boolean = false>(
  options?: Options<GetCombinedFactorFromNehData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCombinedFactorFromNehResponses,
    GetCombinedFactorFromNehErrors,
    ThrowOnError
  >({ url: '/coordinates/combinedFactor/fromNEH', ...options });

export const bulkCombinedFactorFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<BulkCombinedFactorFromNehData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkCombinedFactorFromNehResponses,
    BulkCombinedFactorFromNehErrors,
    ThrowOnError
  >({
    url: '/coordinates/combinedFactor/fromNEH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getGetConvergenceFromLlh = <ThrowOnError extends boolean = false>(
  options?: Options<GetGetConvergenceFromLlhData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetGetConvergenceFromLlhResponses,
    GetGetConvergenceFromLlhErrors,
    ThrowOnError
  >({ url: '/coordinates/convergence/fromLLH', ...options });

export const bulkConvergenceFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<BulkConvergenceFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkConvergenceFromLlhResponses,
    BulkConvergenceFromLlhErrors,
    ThrowOnError
  >({
    url: '/coordinates/convergence/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getGetConvergenceFromLle = <ThrowOnError extends boolean = false>(
  options?: Options<GetGetConvergenceFromLleData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetGetConvergenceFromLleResponses,
    GetGetConvergenceFromLleErrors,
    ThrowOnError
  >({ url: '/coordinates/convergence/fromLLE', ...options });

export const bulkConvergenceFromLle = <ThrowOnError extends boolean = false>(
  options: Options<BulkConvergenceFromLleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkConvergenceFromLleResponses,
    BulkConvergenceFromLleErrors,
    ThrowOnError
  >({
    url: '/coordinates/convergence/fromLLE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getGetConvergenceFromXyz = <ThrowOnError extends boolean = false>(
  options?: Options<GetGetConvergenceFromXyzData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetGetConvergenceFromXyzResponses,
    GetGetConvergenceFromXyzErrors,
    ThrowOnError
  >({ url: '/coordinates/convergence/fromXYZ', ...options });

export const bulkConvergenceFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<BulkConvergenceFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkConvergenceFromXyzResponses,
    BulkConvergenceFromXyzErrors,
    ThrowOnError
  >({
    url: '/coordinates/convergence/fromXYZ',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getGetConvergenceFromNee = <ThrowOnError extends boolean = false>(
  options?: Options<GetGetConvergenceFromNeeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetGetConvergenceFromNeeResponses,
    GetGetConvergenceFromNeeErrors,
    ThrowOnError
  >({ url: '/coordinates/convergence/fromNEE', ...options });

export const bulkConvergenceFromNee = <ThrowOnError extends boolean = false>(
  options: Options<BulkConvergenceFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkConvergenceFromNeeResponses,
    BulkConvergenceFromNeeErrors,
    ThrowOnError
  >({
    url: '/coordinates/convergence/fromNEE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getGetConvergenceFromNeh = <ThrowOnError extends boolean = false>(
  options?: Options<GetGetConvergenceFromNehData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetGetConvergenceFromNehResponses,
    GetGetConvergenceFromNehErrors,
    ThrowOnError
  >({ url: '/coordinates/convergence/fromNEH', ...options });

export const bulkConvergenceFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<BulkConvergenceFromNehData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkConvergenceFromNehResponses,
    BulkConvergenceFromNehErrors,
    ThrowOnError
  >({
    url: '/coordinates/convergence/fromNEH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const listComponents = <ThrowOnError extends boolean = false>(
  options?: Options<ListComponentsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListComponentsResponses,
    ListComponentsErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents', ...options });

export const tenantedListComponents = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListComponentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListComponentsResponses,
    TenantedListComponentsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents',
    ...options,
  });

export const listAliases = <ThrowOnError extends boolean = false>(
  options?: Options<ListAliasesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListAliasesResponses,
    ListAliasesErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents/aliases', ...options });

export const tenantedListAliases = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListAliasesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListAliasesResponses,
    TenantedListAliasesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/aliases',
    ...options,
  });

export const getAlias = <ThrowOnError extends boolean = false>(
  options: Options<GetAliasData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetAliasResponses,
    GetAliasErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents/aliases/{aliasID}', ...options });

export const tenantedGetAlias = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetAliasData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetAliasResponses,
    TenantedGetAliasErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/aliases/{aliasID}',
    ...options,
  });

export const listAreas = <ThrowOnError extends boolean = false>(
  options?: Options<ListAreasData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListAreasResponses,
    ListAreasErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents/areas', ...options });

export const tenantedListAreas = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListAreasData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListAreasResponses,
    TenantedListAreasErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/areas',
    ...options,
  });

export const getComponent = <ThrowOnError extends boolean = false>(
  options: Options<GetComponentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetComponentResponses,
    GetComponentErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents/{componentID}', ...options });

export const tenantedGetComponent = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetComponentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetComponentResponses,
    TenantedGetComponentErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/{componentID}',
    ...options,
  });

export const getComponentByAlias = <ThrowOnError extends boolean = false>(
  options?: Options<GetComponentByAliasData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetComponentByAliasResponses,
    GetComponentByAliasErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents/_byAlias', ...options });

export const tenantedGetComponentByAlias = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetComponentByAliasData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetComponentByAliasResponses,
    TenantedGetComponentByAliasErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/_byAlias',
    ...options,
  });

export const getComponentsByAlias = <ThrowOnError extends boolean = false>(
  options?: Options<GetComponentsByAliasData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetComponentsByAliasResponses,
    GetComponentsByAliasErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents/_byAlias/all', ...options });

export const tenantedGetComponentsByAlias = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetComponentsByAliasData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetComponentsByAliasResponses,
    TenantedGetComponentsByAliasErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/_byAlias/all',
    ...options,
  });

export const getComponentByCsId = <ThrowOnError extends boolean = false>(
  options?: Options<GetComponentByCsIdData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetComponentByCsIdResponses,
    GetComponentByCsIdErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents/_byCsId', ...options });

export const tenantedGetComponentByCsId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetComponentByCsIdData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetComponentByCsIdResponses,
    TenantedGetComponentByCsIdErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/_byCsId',
    ...options,
  });

export const getArea = <ThrowOnError extends boolean = false>(
  options: Options<GetAreaData, ThrowOnError>
) =>
  (options.client ?? client).get<GetAreaResponses, GetAreaErrors, ThrowOnError>(
    { url: '/coordinatesystemcomponents/areas/{areaID}', ...options }
  );

export const tenantedGetArea = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetAreaData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetAreaResponses,
    TenantedGetAreaErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/areas/{areaID}',
    ...options,
  });

export const listFiles = <ThrowOnError extends boolean = false>(
  options: Options<ListFilesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListFilesResponses,
    ListFilesErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents/files/{componentID}', ...options });

export const tenantedListFiles = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListFilesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListFilesResponses,
    TenantedListFilesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/files/{componentID}',
    ...options,
  });

export const getComponentFileSize = <ThrowOnError extends boolean = false>(
  options?: Options<GetComponentFileSizeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetComponentFileSizeResponses,
    GetComponentFileSizeErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents/files/size', ...options });

export const tenantedGetComponentFileSize = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetComponentFileSizeData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetComponentFileSizeResponses,
    TenantedGetComponentFileSizeErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/files/size',
    ...options,
  });

export const getCsib = <ThrowOnError extends boolean = false>(
  options?: Options<GetCsibData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCsibResponses,
    GetCsibErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents/compositions/csib', ...options });

export const tenantedGetCsib = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetCsibData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetCsibResponses,
    TenantedGetCsibErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/compositions/csib',
    ...options,
  });

export const getCoordinateSystem = <ThrowOnError extends boolean = false>(
  options?: Options<GetCoordinateSystemData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCoordinateSystemResponses,
    GetCoordinateSystemErrors,
    ThrowOnError
  >({
    url: '/coordinatesystemcomponents/compositions/coordinateSystem',
    ...options,
  });

export const tenantedGetCoordinateSystem = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetCoordinateSystemData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetCoordinateSystemResponses,
    TenantedGetCoordinateSystemErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/compositions/coordinateSystem',
    ...options,
  });

export const getRftib = <ThrowOnError extends boolean = false>(
  options?: Options<GetRftibData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetRftibResponses,
    GetRftibErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents/compositions/rftib', ...options });

export const tenantedGetRftib = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetRftibData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetRftibResponses,
    TenantedGetRftibErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/compositions/rftib',
    ...options,
  });

export const putCoordinatesystemcomponentsCompositionsWkt = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutCoordinatesystemcomponentsCompositionsWktData,
    ThrowOnError
  >
) =>
  (options.client ?? client).put<
    PutCoordinatesystemcomponentsCompositionsWktResponses,
    PutCoordinatesystemcomponentsCompositionsWktErrors,
    ThrowOnError
  >({
    url: '/coordinatesystemcomponents/compositions/wkt',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const putTenantsByTenantTrnCoordinatesystemcomponentsCompositionsWkt = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutTenantsByTenantTrnCoordinatesystemcomponentsCompositionsWktData,
    ThrowOnError
  >
) =>
  (options.client ?? client).put<
    PutTenantsByTenantTrnCoordinatesystemcomponentsCompositionsWktResponses,
    PutTenantsByTenantTrnCoordinatesystemcomponentsCompositionsWktErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/compositions/wkt',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getDatumTransformation = <ThrowOnError extends boolean = false>(
  options?: Options<GetDatumTransformationData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetDatumTransformationResponses,
    GetDatumTransformationErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents/datumTransformation', ...options });

export const tenantedGetDatumTransformation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetDatumTransformationData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetDatumTransformationResponses,
    TenantedGetDatumTransformationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/datumTransformation',
    ...options,
  });

export const getCoordinatesystemcomponentsAdminExportsCscmdb = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetCoordinatesystemcomponentsAdminExportsCscmdbData,
    ThrowOnError
  >
) =>
  (options?.client ?? client).get<
    GetCoordinatesystemcomponentsAdminExportsCscmdbResponses,
    GetCoordinatesystemcomponentsAdminExportsCscmdbErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents/admin/exports/cscmdb', ...options });

export const getTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCscmdb =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCscmdbData,
      ThrowOnError
    >
  ) =>
    (options.client ?? client).get<
      GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCscmdbResponses,
      GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCscmdbErrors,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/tenants/{tenantTrn}/coordinatesystemcomponents/admin/exports/cscmdb',
      ...options,
    });

export const getCoordinatesystemcomponentsAdminExportsCsdxml = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetCoordinatesystemcomponentsAdminExportsCsdxmlData,
    ThrowOnError
  >
) =>
  (options?.client ?? client).get<
    GetCoordinatesystemcomponentsAdminExportsCsdxmlResponses,
    GetCoordinatesystemcomponentsAdminExportsCsdxmlErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents/admin/exports/csdxml', ...options });

export const getTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCsdxml =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCsdxmlData,
      ThrowOnError
    >
  ) =>
    (options.client ?? client).get<
      GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCsdxmlResponses,
      GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCsdxmlErrors,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/tenants/{tenantTrn}/coordinatesystemcomponents/admin/exports/csdxml',
      ...options,
    });

export const getCoordinatesystemcomponentsAdminVersion = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCoordinatesystemcomponentsAdminVersionData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCoordinatesystemcomponentsAdminVersionResponses,
    GetCoordinatesystemcomponentsAdminVersionErrors,
    ThrowOnError
  >({ url: '/coordinatesystemcomponents/admin/version', ...options });

export const coordinateSystemsReadme = <ThrowOnError extends boolean = false>(
  options?: Options<CoordinateSystemsReadmeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    CoordinateSystemsReadmeResponses,
    CoordinateSystemsReadmeErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/_README', ...options });

export const get = <ThrowOnError extends boolean = false>(
  options?: Options<GetData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetResponses, GetErrors, ThrowOnError>({
    url: '/coordinatesystems/byId',
    ...options,
  });

export const tenantedGet = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetResponses,
    TenantedGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/byId',
    ...options,
  });

export const getCsib64 = <ThrowOnError extends boolean = false>(
  options?: Options<GetCsib64Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCsib64Responses,
    GetCsib64Errors,
    ThrowOnError
  >({ url: '/coordinatesystems/csib/base64', ...options });

export const tenantedGetCsib64 = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetCsib64Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetCsib64Responses,
    TenantedGetCsib64Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/csib/base64',
    ...options,
  });

export const getCalibrationFile = <ThrowOnError extends boolean = false>(
  options?: Options<GetCalibrationFileData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCalibrationFileResponses,
    GetCalibrationFileErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/calibrationFile', ...options });

export const tenantedGetCalibrationFile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetCalibrationFileData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetCalibrationFileResponses,
    TenantedGetCalibrationFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/calibrationFile',
    ...options,
  });

export const getDownloadLinks = <ThrowOnError extends boolean = false>(
  options?: Options<GetDownloadLinksData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetDownloadLinksResponses,
    GetDownloadLinksErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/downloadLinks', ...options });

export const tenantedGetDownloadLinks = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetDownloadLinksData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetDownloadLinksResponses,
    TenantedGetDownloadLinksErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/downloadLinks',
    ...options,
  });

export const listSystems = <ThrowOnError extends boolean = false>(
  options?: Options<ListSystemsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListSystemsResponses,
    ListSystemsErrors,
    ThrowOnError
  >({ url: '/coordinatesystems', ...options });

export const createCoordinateSystem = <ThrowOnError extends boolean = false>(
  options: Options<CreateCoordinateSystemData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateCoordinateSystemResponses,
    CreateCoordinateSystemErrors,
    ThrowOnError
  >({
    url: '/coordinatesystems',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const tenantedListSystems = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListSystemsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListSystemsResponses,
    TenantedListSystemsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems',
    ...options,
  });

export const tenantedCreateCoordinateSystem = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedCreateCoordinateSystemData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedCreateCoordinateSystemResponses,
    TenantedCreateCoordinateSystemErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getCoordinateSystemBySystemIds = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCoordinateSystemBySystemIdsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetCoordinateSystemBySystemIdsResponses,
    GetCoordinateSystemBySystemIdsErrors,
    ThrowOnError
  >({
    url: '/coordinatesystems/{zoneSystemId}/{datumSystemId}/{geoidSystemId}',
    ...options,
  });

export const tenantedGetCoordinateSystemBySystemIds = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetCoordinateSystemBySystemIdsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetCoordinateSystemBySystemIdsResponses,
    TenantedGetCoordinateSystemBySystemIdsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/{zoneSystemId}/{datumSystemId}/{geoidSystemId}',
    ...options,
  });

export const getCoordinateSystemFromCustomDatum = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCoordinateSystemFromCustomDatumData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCoordinateSystemFromCustomDatumResponses,
    GetCoordinateSystemFromCustomDatumErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/custom', ...options });

export const tenantedGetCoordinateSystemFromCustomDatum = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetCoordinateSystemFromCustomDatumData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetCoordinateSystemFromCustomDatumResponses,
    TenantedGetCoordinateSystemFromCustomDatumErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/custom',
    ...options,
  });

export const getFromDcFile = <ThrowOnError extends boolean = false>(
  options: Options<GetFromDcFileData, ThrowOnError>
) =>
  (options.client ?? client).put<
    GetFromDcFileResponses,
    GetFromDcFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/coordinatesystems/imports/dc/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const tenantedGetFromDcFile = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromDcFileData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromDcFileResponses,
    TenantedGetFromDcFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/dc/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const getFromDc = <ThrowOnError extends boolean = false>(
  options: Options<GetFromDcData, ThrowOnError>
) =>
  (options.client ?? client).put<
    GetFromDcResponses,
    GetFromDcErrors,
    ThrowOnError
  >({
    bodySerializer: null,
    url: '/coordinatesystems/imports/dc',
    ...options,
    headers: {
      'Content-Type': 'text/plain',
      ...options.headers,
    },
  });

export const tenantedGetFromDc = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromDcData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromDcResponses,
    TenantedGetFromDcErrors,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/dc',
    ...options,
    headers: {
      'Content-Type': 'text/plain',
      ...options.headers,
    },
  });

export const getFromJxlFile = <ThrowOnError extends boolean = false>(
  options: Options<GetFromJxlFileData, ThrowOnError>
) =>
  (options.client ?? client).put<
    GetFromJxlFileResponses,
    GetFromJxlFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/coordinatesystems/imports/jxl/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const tenantedGetFromJxlFile = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromJxlFileData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromJxlFileResponses,
    TenantedGetFromJxlFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/jxl/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const getFromJxl = <ThrowOnError extends boolean = false>(
  options: Options<GetFromJxlData, ThrowOnError>
) =>
  (options.client ?? client).put<
    GetFromJxlResponses,
    GetFromJxlErrors,
    ThrowOnError
  >({
    bodySerializer: null,
    url: '/coordinatesystems/imports/jxl',
    ...options,
    headers: {
      'Content-Type': 'text/plain',
      ...options.headers,
    },
  });

export const tenantedGetFromJxl = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromJxlData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromJxlResponses,
    TenantedGetFromJxlErrors,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/jxl',
    ...options,
    headers: {
      'Content-Type': 'text/plain',
      ...options.headers,
    },
  });

export const getFromWktFile = <ThrowOnError extends boolean = false>(
  options: Options<GetFromWktFileData, ThrowOnError>
) =>
  (options.client ?? client).put<
    GetFromWktFileResponses,
    GetFromWktFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/coordinatesystems/imports/wkt/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const tenantedGetFromWktFile = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromWktFileData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromWktFileResponses,
    TenantedGetFromWktFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/wkt/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const getFromWkt = <ThrowOnError extends boolean = false>(
  options: Options<GetFromWktData, ThrowOnError>
) =>
  (options.client ?? client).put<
    GetFromWktResponses,
    GetFromWktErrors,
    ThrowOnError
  >({
    url: '/coordinatesystems/imports/wkt',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const tenantedGetFromWkt = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromWktData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromWktResponses,
    TenantedGetFromWktErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/wkt',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getFromCsib = <ThrowOnError extends boolean = false>(
  options: Options<GetFromCsibData, ThrowOnError>
) =>
  (options.client ?? client).put<
    GetFromCsibResponses,
    GetFromCsibErrors,
    ThrowOnError
  >({
    bodySerializer: null,
    url: '/coordinatesystems/imports/csib',
    ...options,
    headers: {
      'Content-Type': 'application/octet-stream',
      ...options.headers,
    },
  });

export const tenantedGetFromCsib = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromCsibData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromCsibResponses,
    TenantedGetFromCsibErrors,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/csib',
    ...options,
    headers: {
      'Content-Type': 'application/octet-stream',
      ...options.headers,
    },
  });

export const getFromBase64Csib = <ThrowOnError extends boolean = false>(
  options?: Options<GetFromBase64CsibData, ThrowOnError>
) =>
  (options?.client ?? client).put<
    GetFromBase64CsibResponses,
    GetFromBase64CsibErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/imports/csib/base64', ...options });

export const tenantedGetFromBase64Csib = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromBase64CsibData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromBase64CsibResponses,
    TenantedGetFromBase64CsibErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/csib/base64',
    ...options,
  });

export const getFromEpsg = <ThrowOnError extends boolean = false>(
  options: Options<GetFromEpsgData, ThrowOnError>
) =>
  (options.client ?? client).put<
    GetFromEpsgResponses,
    GetFromEpsgErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/imports/epsg/{code}', ...options });

export const tenantedGetFromEpsg = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromEpsgData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromEpsgResponses,
    TenantedGetFromEpsgErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/epsg/{code}',
    ...options,
  });

export const getWktFromEpsg = <ThrowOnError extends boolean = false>(
  options: Options<GetWktFromEpsgData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetWktFromEpsgResponses,
    GetWktFromEpsgErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/epsg/{code}/wkt', ...options });

export const tenantedGetWktFromEpsg = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetWktFromEpsgData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetWktFromEpsgResponses,
    TenantedGetWktFromEpsgErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/epsg/{code}/wkt',
    ...options,
  });

export const listDatums = <ThrowOnError extends boolean = false>(
  options?: Options<ListDatumsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListDatumsResponses,
    ListDatumsErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/datums', ...options });

export const tenantedListDatums = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListDatumsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListDatumsResponses,
    TenantedListDatumsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/datums',
    ...options,
  });

export const getDatum = <ThrowOnError extends boolean = false>(
  options: Options<GetDatumData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetDatumResponses,
    GetDatumErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/datums/{systemId}', ...options });

export const tenantedGetDatum = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetDatumData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetDatumResponses,
    TenantedGetDatumErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/datums/{systemId}',
    ...options,
  });

export const listReferenceFrames = <ThrowOnError extends boolean = false>(
  options?: Options<ListReferenceFramesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListReferenceFramesResponses,
    ListReferenceFramesErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/referenceframes', ...options });

export const tenantedListReferenceFrames = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedListReferenceFramesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListReferenceFramesResponses,
    TenantedListReferenceFramesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/referenceframes',
    ...options,
  });

export const getReferenceFrame = <ThrowOnError extends boolean = false>(
  options: Options<GetReferenceFrameData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetReferenceFrameResponses,
    GetReferenceFrameErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/referenceframes/{systemId}', ...options });

export const tenantedGetReferenceFrame = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetReferenceFrameData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetReferenceFrameResponses,
    TenantedGetReferenceFrameErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/referenceframes/{systemId}',
    ...options,
  });

export const listZoneGroups = <ThrowOnError extends boolean = false>(
  options?: Options<ListZoneGroupsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListZoneGroupsResponses,
    ListZoneGroupsErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/zonegroups', ...options });

export const tenantedListZoneGroups = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListZoneGroupsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListZoneGroupsResponses,
    TenantedListZoneGroupsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/zonegroups',
    ...options,
  });

export const getZoneGroup = <ThrowOnError extends boolean = false>(
  options: Options<GetZoneGroupData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetZoneGroupResponses,
    GetZoneGroupErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/zonegroups/{systemId}', ...options });

export const tenantedGetZoneGroup = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetZoneGroupData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetZoneGroupResponses,
    TenantedGetZoneGroupErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/zonegroups/{systemId}',
    ...options,
  });

/**
 * This route has a typo in it, and will be removed in a future release. Use the 'ListZonesInGroup' route (/coordinatesystems/zonegroups/{systemId:int}/zones) instead.
 *
 * @deprecated
 */
export const obsoleteListZonesInGroup = <ThrowOnError extends boolean = false>(
  options: Options<ObsoleteListZonesInGroupData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ObsoleteListZonesInGroupResponses,
    ObsoleteListZonesInGroupErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/zonesgroups/{systemId}/zones', ...options });

export const listZonesInGroup = <ThrowOnError extends boolean = false>(
  options: Options<ListZonesInGroupData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListZonesInGroupResponses,
    ListZonesInGroupErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/zonegroups/{systemId}/zones', ...options });

export const tenantedListZonesInGroup = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListZonesInGroupData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListZonesInGroupResponses,
    TenantedListZonesInGroupErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/zonegroups/{systemId}/zones',
    ...options,
  });

export const listGeoids = <ThrowOnError extends boolean = false>(
  options?: Options<ListGeoidsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListGeoidsResponses,
    ListGeoidsErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/geoids', ...options });

export const tenantedListGeoids = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListGeoidsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListGeoidsResponses,
    TenantedListGeoidsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/geoids',
    ...options,
  });

export const getGeoid = <ThrowOnError extends boolean = false>(
  options: Options<GetGeoidData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetGeoidResponses,
    GetGeoidErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/geoids/{systemId}', ...options });

export const tenantedGetGeoid = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetGeoidData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetGeoidResponses,
    TenantedGetGeoidErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/geoids/{systemId}',
    ...options,
  });

export const listAllZones = <ThrowOnError extends boolean = false>(
  options?: Options<ListAllZonesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListAllZonesResponses,
    ListAllZonesErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/zones', ...options });

export const tenantedListAllZones = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListAllZonesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListAllZonesResponses,
    TenantedListAllZonesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/zones',
    ...options,
  });

export const getZone = <ThrowOnError extends boolean = false>(
  options: Options<GetZoneData, ThrowOnError>
) =>
  (options.client ?? client).get<GetZoneResponses, GetZoneErrors, ThrowOnError>(
    { url: '/coordinatesystems/zones/{systemId}', ...options }
  );

export const tenantedGetZone = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetZoneData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetZoneResponses,
    TenantedGetZoneErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/zones/{systemId}',
    ...options,
  });

export const getZoneDefaultDatum = <ThrowOnError extends boolean = false>(
  options: Options<GetZoneDefaultDatumData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetZoneDefaultDatumResponses,
    GetZoneDefaultDatumErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/zones/{systemId}/defaultDatum', ...options });

export const tenantedGetZoneDefaultDatum = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetZoneDefaultDatumData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetZoneDefaultDatumResponses,
    TenantedGetZoneDefaultDatumErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/zones/{systemId}/defaultDatum',
    ...options,
  });

export const getZoneDefaultGeoid = <ThrowOnError extends boolean = false>(
  options: Options<GetZoneDefaultGeoidData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetZoneDefaultGeoidResponses,
    GetZoneDefaultGeoidErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/zones/{systemId}/defaultGeoid', ...options });

export const tenantedGetZoneDefaultGeoid = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetZoneDefaultGeoidData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetZoneDefaultGeoidResponses,
    TenantedGetZoneDefaultGeoidErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/zones/{systemId}/defaultGeoid',
    ...options,
  });

export const downloadGeodataFiles = <ThrowOnError extends boolean = false>(
  options?: Options<DownloadGeodataFilesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    unknown,
    DownloadGeodataFilesErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/geodataFiles', ...options });

export const getGeodataFileSize = <ThrowOnError extends boolean = false>(
  options?: Options<GetGeodataFileSizeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetGeodataFileSizeResponses,
    GetGeodataFileSizeErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/geodataFiles/size', ...options });

export const tenantedGetGeodataFilesSize = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetGeodataFilesSizeData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetGeodataFilesSizeResponses,
    TenantedGetGeodataFilesSizeErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/geodataFiles/size',
    ...options,
  });

export const downloadCoordSystemDatabase = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<DownloadCoordSystemDatabaseData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    DownloadCoordSystemDatabaseResponses,
    DownloadCoordSystemDatabaseErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/coordSystemDatabaseFile', ...options });

export const tenantedDownloadCoordSystemDatabase = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedDownloadCoordSystemDatabaseData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedDownloadCoordSystemDatabaseResponses,
    TenantedDownloadCoordSystemDatabaseErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/coordSystemDatabaseFile',
    ...options,
  });

export const downloadTimeDependentTransformationDatabase = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    DownloadTimeDependentTransformationDatabaseData,
    ThrowOnError
  >
) =>
  (options?.client ?? client).get<
    unknown,
    DownloadTimeDependentTransformationDatabaseErrors,
    ThrowOnError
  >({
    url: '/coordinatesystems/timeDependentTransformationDatabaseFile',
    ...options,
  });

export const tenantedDownloadTimeDependentTransformationDatabase = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TenantedDownloadTimeDependentTransformationDatabaseData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    unknown,
    TenantedDownloadTimeDependentTransformationDatabaseErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/timeDependentTransformationDatabaseFile',
    ...options,
  });

export const getWktAngularUnits = <ThrowOnError extends boolean = false>(
  options?: Options<GetWktAngularUnitsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetWktAngularUnitsResponses,
    GetWktAngularUnitsErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/wkt/angularunits', ...options });

export const tenantedGetWktAngularUnits = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetWktAngularUnitsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetWktAngularUnitsResponses,
    TenantedGetWktAngularUnitsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/wkt/angularunits',
    ...options,
  });

export const getWktLinearUnits = <ThrowOnError extends boolean = false>(
  options?: Options<GetWktLinearUnitsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetWktLinearUnitsResponses,
    GetWktLinearUnitsErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/wkt/linearunits', ...options });

export const tenantedGetWktLinearUnits = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetWktLinearUnitsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetWktLinearUnitsResponses,
    TenantedGetWktLinearUnitsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/wkt/linearunits',
    ...options,
  });

export const getWkt = <ThrowOnError extends boolean = false>(
  options?: Options<GetWktData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetWktResponses, GetWktErrors, ThrowOnError>({
    url: '/coordinatesystems/wkt',
    ...options,
  });

export const tenantedGetWkt = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetWktData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetWktResponses,
    TenantedGetWktErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/wkt',
    ...options,
  });

export const getJxl = <ThrowOnError extends boolean = false>(
  options?: Options<GetJxlData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetJxlResponses, GetJxlErrors, ThrowOnError>({
    url: '/coordinatesystems/jxl',
    ...options,
  });

export const tenantedGetJxl = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetJxlData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetJxlResponses,
    TenantedGetJxlErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/jxl',
    ...options,
  });

export const getAsGeographic = <ThrowOnError extends boolean = false>(
  options?: Options<GetAsGeographicData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetAsGeographicResponses,
    GetAsGeographicErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/geographic', ...options });

export const tenantedGetAsGeographic = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetAsGeographicData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetAsGeographicResponses,
    TenantedGetAsGeographicErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/geographic',
    ...options,
  });

export const getJxlByEpsg = <ThrowOnError extends boolean = false>(
  options?: Options<GetJxlByEpsgData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetJxlByEpsgResponses,
    GetJxlByEpsgErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/jxl/byEpsg', ...options });

export const tenantedGetJxlByEpsg = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetJxlByEpsgData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetJxlByEpsgResponses,
    TenantedGetJxlByEpsgErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/jxl/byEpsg',
    ...options,
  });

export const getShiftGridInfo = <ThrowOnError extends boolean = false>(
  options?: Options<GetShiftGridInfoData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetShiftGridInfoResponses,
    GetShiftGridInfoErrors,
    ThrowOnError
  >({ url: '/coordinatesystems/shiftgrids', ...options });

export const tenantedGetShiftGridInfo = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetShiftGridInfoData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetShiftGridInfoResponses,
    TenantedGetShiftGridInfoErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/shiftgrids',
    ...options,
  });

export const deleteMySystem = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteMySystemData, ThrowOnError>
) =>
  (options?.client ?? client).delete<
    DeleteMySystemResponses,
    DeleteMySystemErrors,
    ThrowOnError
  >({ url: '/mysystems', ...options });

export const listMySystems = <ThrowOnError extends boolean = false>(
  options?: Options<ListMySystemsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListMySystemsResponses,
    ListMySystemsErrors,
    ThrowOnError
  >({ url: '/mysystems', ...options });

export const addMySystem = <ThrowOnError extends boolean = false>(
  options?: Options<AddMySystemData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    AddMySystemResponses,
    AddMySystemErrors,
    ThrowOnError
  >({ url: '/mysystems', ...options });

export const transformsReadme = <ThrowOnError extends boolean = false>(
  options?: Options<TransformsReadmeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    TransformsReadmeResponses,
    TransformsReadmeErrors,
    ThrowOnError
  >({ url: '/transforms/_README', ...options });

export const transformCoordinates = <ThrowOnError extends boolean = false>(
  options: Options<TransformCoordinatesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TransformCoordinatesResponses,
    TransformCoordinatesErrors,
    ThrowOnError
  >({
    url: '/transforms/coordinates',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const tenantedTransformCoordinates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedTransformCoordinatesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedTransformCoordinatesResponses,
    TenantedTransformCoordinatesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/transforms/coordinates',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const transformToGlobal = <ThrowOnError extends boolean = false>(
  options: Options<TransformToGlobalData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TransformToGlobalResponses,
    TransformToGlobalErrors,
    ThrowOnError
  >({
    url: '/transforms/globals',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const tenantedTransformToGlobal = <ThrowOnError extends boolean = false>(
  options: Options<TenantedTransformToGlobalData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedTransformToGlobalResponses,
    TenantedTransformToGlobalErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/transforms/globals',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const transformToLocal = <ThrowOnError extends boolean = false>(
  options: Options<TransformToLocalData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TransformToLocalResponses,
    TransformToLocalErrors,
    ThrowOnError
  >({
    url: '/transforms/locals',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const tenantedTransformToLocal = <ThrowOnError extends boolean = false>(
  options: Options<TenantedTransformToLocalData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedTransformToLocalResponses,
    TenantedTransformToLocalErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/transforms/locals',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const transformToEcefGlobal = <ThrowOnError extends boolean = false>(
  options: Options<TransformToEcefGlobalData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TransformToEcefGlobalResponses,
    TransformToEcefGlobalErrors,
    ThrowOnError
  >({
    url: '/transforms/globals/ecef',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const tenantedTransformToEcefGlobal = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedTransformToEcefGlobalData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedTransformToEcefGlobalResponses,
    TenantedTransformToEcefGlobalErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/transforms/globals/ecef',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getScaleFactors = <ThrowOnError extends boolean = false>(
  options: Options<GetScaleFactorsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetScaleFactorsResponses,
    GetScaleFactorsErrors,
    ThrowOnError
  >({
    url: '/transforms/scaleFactors',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const tenantedGetScaleFactors = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetScaleFactorsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedGetScaleFactorsResponses,
    TenantedGetScaleFactorsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/transforms/scaleFactors',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getCombinedFactors = <ThrowOnError extends boolean = false>(
  options: Options<GetCombinedFactorsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetCombinedFactorsResponses,
    GetCombinedFactorsErrors,
    ThrowOnError
  >({
    url: '/transforms/combinedFactors',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const tenantedGetCombinedFactors = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetCombinedFactorsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedGetCombinedFactorsResponses,
    TenantedGetCombinedFactorsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/transforms/combinedFactors',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getConvergences = <ThrowOnError extends boolean = false>(
  options: Options<GetConvergencesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetConvergencesResponses,
    GetConvergencesErrors,
    ThrowOnError
  >({
    url: '/transforms/convergences',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const tenantedGetConvergences = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetConvergencesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedGetConvergencesResponses,
    TenantedGetConvergencesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/transforms/convergences',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });
